import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Sparkles, X } from "lucide-react";
import { toast } from "sonner";

export default function MysteryRewardPopup() {
  const { user } = useAuth();
  const [reward, setReward] = useState(null);

  useEffect(() => {
    if (!user || user.role !== "customer") return;
    const seenKey = "bd_mystery_seen";
    api.get("/mystery-rewards/my").then((r) => {
      const unclaimed = r.data.find((m) => !m.claimed);
      if (!unclaimed) return;
      const seen = JSON.parse(localStorage.getItem(seenKey) || "[]");
      if (seen.includes(unclaimed.id)) return;
      setReward(unclaimed);
    }).catch(() => {});
  }, [user]);

  const dismiss = () => {
    if (!reward) return;
    const seenKey = "bd_mystery_seen";
    const seen = JSON.parse(localStorage.getItem(seenKey) || "[]");
    seen.push(reward.id);
    localStorage.setItem(seenKey, JSON.stringify(seen));
    setReward(null);
  };

  const claim = async () => {
    if (!reward) return;
    await api.put(`/mystery-rewards/${reward.id}/claim`);
    toast.success("Reward claimed! 🎁");
    dismiss();
  };

  if (!reward) return null;

  return (
    <div className="fixed inset-0 z-50 bg-slate-900/60 flex items-center justify-center p-4" data-testid="mystery-popup">
      <div className="card-clay p-7 max-w-md w-full bg-gradient-to-br from-amber-50 to-orange-50 border-amber-200 relative animate-in zoom-in-95">
        <button onClick={dismiss} className="absolute top-3 right-3 p-1.5 rounded-xl hover:bg-amber-100" data-testid="mystery-close"><X size={16}/></button>
        <div className="w-16 h-16 mx-auto rounded-3xl bg-amber-500 border-b-4 border-amber-700 flex items-center justify-center">
          <Sparkles className="text-white" size={28} strokeWidth={2.5}/>
        </div>
        <h2 className="font-fredoka text-2xl font-bold text-slate-900 text-center mt-4">{reward.title}</h2>
        <p className="text-slate-700 text-center mt-2">{reward.body}</p>
        <button onClick={claim} className="btn-push-amber w-full mt-5 py-3" data-testid="mystery-claim">Claim it! 🎉</button>
      </div>
    </div>
  );
}
